import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';

export interface ReportStateModel {
  isLoaded: boolean;
  loadedReportId: number;
  url: string | any;
  refresh: boolean;
  isReportInPendingState: boolean;
  isFrameLoaded: boolean;
}

export namespace ReportAction {
  export class Load {
    static readonly type = '[Report] load report';

    constructor(public url: string, public id: number) {
    }
  }

  export class Unload {
    static readonly type = '[Report] unload report';

    constructor() {
    }
  }

  export class TogglePendingState {
    static readonly type = '[Report] toggle pending state';

    constructor(public isPending: boolean) {
    }
  }

  export class Refresh {
    static readonly type = '[Report] refresh';

    constructor() {
    }
  }

  export class SetFrameIsLoaded {
    static readonly type = '[Report] set report iframe is loaded';

    constructor() {
    }
  }
}


@State<ReportStateModel>({
  name: ReportState.storeName,
  defaults: ReportState.defaults
})
@Injectable()
export class ReportState {
  static readonly storeName = 'report';
  static readonly defaults: ReportStateModel = {
    isLoaded: false,
    loadedReportId: -1,
    url: null,
    refresh: false,
    isReportInPendingState: false,
    isFrameLoaded: false
  };

  @Selector()
  static getReportUrl(state: ReportStateModel) {
    return state.url;
  }

  @Action(ReportAction.Load)
  load(ctx: StateContext<ReportStateModel>, info: ReportAction.Load) {
    const state = ctx.getState();

    ctx.patchState({
      ...state,
      url: info.url,
      isLoaded: true,
      loadedReportId: info.id,
      isFrameLoaded: false,
    });
  }

  @Action(ReportAction.TogglePendingState)
  togglePendingState(ctx: StateContext<ReportStateModel>, info: ReportAction.TogglePendingState) {
    const state = ctx.getState();

    ctx.patchState({
      ...state,
      isReportInPendingState: info.isPending
    });
  }

  @Action(ReportAction.Refresh)
  refresh(ctx: StateContext<ReportStateModel>) {
    const state = ctx.getState();
    const url = ctx.getState().url;
    ctx.patchState({
      ...state, url: ''
    });

    setTimeout(() => {
      ctx.patchState({
        ...state, url
      });
    }, 1000);
  }

  @Action(ReportAction.SetFrameIsLoaded)
  setFrameIsLoaded(ctx: StateContext<ReportStateModel>) {
    const state = ctx.getState();
      ctx.patchState({
        ...state,
        isFrameLoaded: true
      });
  }


  @Action(ReportAction.Unload)
  unload(ctx: StateContext<ReportStateModel>) {
    ctx.patchState(ReportState.defaults);
  }
}
